import { Tooltip, Zoom } from "@mui/material";
import React, { type ReactNode } from "react";

export const TooltipOverflow = ({
  isOverflowing,
  text,
  tooltip,
}: {
  isOverflowing?: boolean;
  text: React.ReactNode;
  tooltip?: string | ReactNode;
}) => {
  if (!React.isValidElement(text) && typeof text !== "string") {
    return null;
  }
  if (isOverflowing) {
    return (
      <Tooltip data-testid="tooltipoverflow-tooltip" title={tooltip || text} arrow slots={{
        transition: Zoom
      }}>
        <span>{text}</span>
      </Tooltip>
    );
  }
  return <span>{text}</span>;
};
